import { Component, Input } from "@angular/core";
import { Observable, Subscriber } from "rxjs";
import { Reference } from "../reference";

@Component({
  selector: 'selectable-reference-result',
  templateUrl: './selectable-reference-result.component.html',
})
export class SelectableReferenceResultComponent {
  @Input()
  public reference!: Reference;

  private selected = false;
  private subscribers: Subscriber<Reference>[] = [];

  public isSelected() {
    return this.selected;
  }

  public onToggle(): Observable<Reference> {
    return new Observable<Reference>(subscriber => { this.subscribers.push(subscriber); });
  }

  public toggleSelected(reference: Reference) {
    for (const subscriber of this.subscribers) {
      subscriber.next(reference);
    }

    this.selected = !this.selected;
  }
}